// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"208674bf","864":"32147288"}[chunkId] + ".chunk.js";
};